import React from 'react';
import PropTypes from 'prop-types';
import { useDictionary } from '../../../utilities/hooks/UseDictionary';
import { ReactComponent as StarIcon } from '../../../assets/icons/ic_star_filled.svg';

// "Business plan" upsell pill.
//   - Default: straddles the top edge of a subscription-gated button — render
//     it as the last child of a button carrying the `has-premium-badge` class.
//   - `inline`: flows next to other content (e.g. beside a section label),
//     with no absolute positioning.
const PremiumBadge = ({ inline }) => {
	const dictionary = useDictionary();

	return (
		<div
			className={`premium-badge${inline ? ' premium-badge--inline' : ''}`}
			data-testid="premium-badge"
		>
			<StarIcon className="premium-badge-icon" />
			<span>{dictionary.business_plan}</span>
		</div>
	);
};

PremiumBadge.propTypes = {
	inline: PropTypes.bool
};

PremiumBadge.defaultProps = {
	inline: false
};

export default PremiumBadge;
